import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import { ModelUserAuth, type IModelLoginRequest } from "./dto/jwt.dto";
import { JWTRepository } from "./jwt.repository";


export class JWTService extends BaseService {
  private jwtRepository = new JWTRepository(this.api, this.configService);

  async login(params: IModelLoginRequest): Promise<ModelUserAuth | undefined> {
    const { $functions } = useNuxtApp()
    let dataResult;
    try {
      const res = await this.jwtRepository.login(params);
      const resData = res.data.value;
      const resError = res?.error?.value;
      
      // จัดการกรณี error
      if (resError) {
        const errorBody = resError.data; // { message, error, statusCode }
        $functions.notify.error({
          text: errorBody?.message || 'Login failed',
          isError: true
        });
        return undefined;
      }
      
      // จัดการกรณี success
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAuth(resData.data)
        console.log('login', resData.data, dataResult)
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true
      });
      console.log(err, JWTService.name);
    }
    return dataResult;
  }

  async logout(): Promise<boolean> {
    const { $functions } = useNuxtApp();
    let isSuccess = false;
    try {
      const res = await this.jwtRepository.logout();
      const resData = res.data.value;
      isSuccess = true;
      console.log('logout', resData, isSuccess);
    } catch (err: any) {
      // Ignore error and continue with logout process
      console.log('Logout error (ignored):', err, JWTService.name);
      isSuccess = true;
    }
    return isSuccess;
  }
}
